export default {
  name: "App",
  components: {},
  mounted() {
    // 解决页面不刷新问题
    if (location.href.includes("page")) {
      let currenthref = location.href.split("?");
      let name = currenthref[1].split("=")[1] + "?" + currenthref[2].replace("#/", "");
      window.location.href = location.protocol + "//" + location.host + location.pathname + "#/" + name;
    }
  }
};